import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { Store } from 'redux';
import { initSlice } from '../features/init/initSlice';
import { ConnectionArgs } from './connect';
import { getBasePath } from './path';

export const getI18n = (connectionArgs: ConnectionArgs, store: Store): Promise<any> => {
  const i = i18n
    .use(Backend)
    .use(initReactI18next) // bind react-i18next to the instance
    .init({
      lng: connectionArgs.locale,
      fallbackLng: [],
      debug: connectionArgs.log > 0,

      interpolation: {
        escapeValue: false, // not needed for react!!
        format: function(value, format, lng) {
            if (format === 'bold') return '<b>'+value+'</b>';
            return value;
        }
      },

      backend: {
        loadPath: getBasePath()+'locales/{{lng}}/{{ns}}.json',
      },

      react: {
        useSuspense: false,
      },

      // react i18next special options (optional)
      // override if needed - omit if ok with defaults
      /*
      react: {
        bindI18n: 'languageChanged',
        bindI18nStore: '',
        transEmptyNodeValue: '',
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
        useSuspense: true,
      }
      */
    });

  i18n.on(
    'loaded',
    (loaded: Record<string, string[]>) => {
      if (loaded[connectionArgs.locale]) {
        store.dispatch(initSlice.actions.setLoadedTranslations(true));
      }
    }
  );

  return i;
}
